module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-timber-hayman-0.10f7f09f.jpg";